module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "create-company"
  }, [_c('Form', {
    ref: "subForm",
    attrs: {
      "model": _vm.subForm,
      "rules": _vm.subFormRules
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "decs"
  }, [_vm._v("请完善企业信息")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "企业名称",
      "prop": "companyName",
      "label-width": 90
    }
  }, [_c('Select', {
    staticClass: "no-icon",
    staticStyle: {
      "width": "350px",
      "text-align": "left"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "placeholder": "请输入和营业执照一致的企业全称",
      "remote-method": _vm.companySearch
    },
    model: {
      value: (_vm.subForm.companyName),
      callback: function($$v) {
        _vm.$set(_vm.subForm, "companyName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "subForm.companyName"
    }
  }, _vm._l((_vm.companyList), function(option) {
    return _c('Option', {
      key: option.customerName,
      attrs: {
        "value": option.customerName
      }
    }, [_vm._v(_vm._s(option.customerName))])
  }), 1), _vm._v(" "), (_vm.showValidate) ? _c('p', {
    staticStyle: {
      "text-align": "left",
      "padding-left": "15px",
      "color": "#f00"
    }
  }, [_vm._v("该企业已存在,请前往"), _c('span', {
    staticClass: "login",
    on: {
      "click": function($event) {
        return _vm.previous('3')
      }
    }
  }, [_vm._v("【加入企业】")])]) : _vm._e()], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "企业性质",
      "prop": "nature",
      "label-width": 90
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "350px",
      "text-align": "left"
    },
    attrs: {
      "placeholder": "请选择您的企业性质"
    },
    model: {
      value: (_vm.subForm.nature),
      callback: function($$v) {
        _vm.$set(_vm.subForm, "nature", $$v)
      },
      expression: "subForm.nature"
    }
  }, _vm._l((_vm.nature), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      },
      domProps: {
        "textContent": _vm._s(item.label)
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "企业类型",
      "prop": "businessType",
      "label-width": 90
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "350px",
      "text-align": "left"
    },
    attrs: {
      "placeholder": "请选择您的企业类型"
    },
    model: {
      value: (_vm.subForm.businessType),
      callback: function($$v) {
        _vm.$set(_vm.subForm, "businessType", $$v)
      },
      expression: "subForm.businessType"
    }
  }, _vm._l((_vm.businessType), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      },
      domProps: {
        "textContent": _vm._s(item.label)
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "企业规模",
      "prop": "companyScaleType",
      "label-width": 90
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "350px",
      "text-align": "left"
    },
    attrs: {
      "placeholder": "请选择您的企业人员规模"
    },
    model: {
      value: (_vm.subForm.companyScaleType),
      callback: function($$v) {
        _vm.$set(_vm.subForm, "companyScaleType", $$v)
      },
      expression: "subForm.companyScaleType"
    }
  }, _vm._l((_vm.companyScaleTypeList), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      },
      domProps: {
        "textContent": _vm._s(item.label)
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "主管税务机关",
      "prop": "competentTaxAuthority",
      "label-width": 90
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入主管税务机关"
    },
    model: {
      value: (_vm.subForm.competentTaxAuthority),
      callback: function($$v) {
        _vm.$set(_vm.subForm, "competentTaxAuthority", $$v)
      },
      expression: "subForm.competentTaxAuthority"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "申请人角色",
      "prop": "characterPosition",
      "label-width": 90
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "350px",
      "text-align": "left"
    },
    attrs: {
      "placeholder": "请选择申请人角色"
    },
    model: {
      value: (_vm.subForm.characterPosition),
      callback: function($$v) {
        _vm.$set(_vm.subForm, "characterPosition", $$v)
      },
      expression: "subForm.characterPosition"
    }
  }, _vm._l((_vm.characterPositionList), function(item) {
    return _c('Option', {
      key: item,
      attrs: {
        "value": item
      },
      domProps: {
        "textContent": _vm._s(item)
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1), _vm._v(" "), (_vm.subForm.characterPosition == '其他') ? _c('FormItem', {
    attrs: {
      "label": "",
      "prop": "characterPosition",
      "label-width": 90
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入申请人角色"
    },
    model: {
      value: (_vm.characterPositionElse),
      callback: function($$v) {
        _vm.characterPositionElse = $$v
      },
      expression: "characterPositionElse"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('FormItem', {
    staticClass: "ivu-form-item-required",
    attrs: {
      "label": "工作邮箱",
      "label-width": 90,
      "prop": "mail"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入申请人角色"
    },
    model: {
      value: (_vm.subForm.mail),
      callback: function($$v) {
        _vm.$set(_vm.subForm, "mail", $$v)
      },
      expression: "subForm.mail"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "decs"
  }, [_vm._v("企业实际所在地址")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "办公地址",
      "prop": "companyAddress",
      "label-width": 90
    }
  }, [_c('FormItem', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "prop": "city",
      "label": "",
      "label-width": 0
    }
  }, [_c('Cascader', {
    staticStyle: {
      "width": "350px",
      "text-align": "left"
    },
    attrs: {
      "data": _vm.cityData,
      "filterable": ""
    },
    model: {
      value: (_vm.subForm.city),
      callback: function($$v) {
        _vm.$set(_vm.subForm, "city", $$v)
      },
      expression: "subForm.city"
    }
  })], 1), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入完整具体到门牌号的地址"
    },
    model: {
      value: (_vm.subForm.companyAddress),
      callback: function($$v) {
        _vm.$set(_vm.subForm, "companyAddress", $$v)
      },
      expression: "subForm.companyAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', {
    staticClass: "decs",
    staticStyle: {
      "margin-bottom": "-2px"
    }
  }, [_vm._v("营业执照")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "uploadFile"
    }
  }, [_c('div', {
    staticClass: "upload-file-btn",
    class: {
      pointer: !_vm.imgurl
    },
    staticStyle: {
      "position": "relative",
      "overflow": "hidden",
      "width": "100%",
      "cursor": "pointer"
    }
  }, [(!_vm.imgurl) ? [_c('Upload', {
    ref: "uploadImages",
    staticClass: "upload-file",
    attrs: {
      "multiple": "",
      "show-upload-list": false,
      "format": ['jpg', 'jpeg', 'png', 'gif', 'rtf', 'pdf'],
      "on-format-error": _vm.handleFormatError,
      "max-size": 10240,
      "on-exceeded-size": _vm.handleMaxSize,
      "before-upload": _vm.handleUpload,
      "on-success": _vm.uploadSuccess,
      "name": "uploadFile",
      "action": ""
    }
  }, [_c('div', {
    staticClass: "upload-box"
  }, [_c('img', {
    staticClass: "zhizhao",
    attrs: {
      "src": require("../../images/zhizhao.png")
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "add-icon",
    attrs: {
      "src": require("../../images/add.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("点击上传您的营业执照")])])])] : _vm._e(), _vm._v(" "), (_vm.imgurl) ? [(_vm.isPDF) ? _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "304px",
      "margin-top": "30px"
    },
    attrs: {
      "src": _vm.imgurl
    }
  }) : _c('img', {
    staticClass: "zhizhao",
    attrs: {
      "src": _vm.imgurl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sign",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.clearImage
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-trash-outline",
      "size": "18"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "ivu-form-item-error-tip",
    domProps: {
      "textContent": _vm._s(_vm.uploadErr)
    }
  })])], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('Button', {
    staticClass: "next-btn",
    staticStyle: {
      "width": "200px",
      "border-color": "#fff"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.previous('1')
      }
    }
  }, [_vm._v("\n        加入企业\n      ")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.valiSubmit('subForm')
      }
    }
  }, [_vm._v("\n        立即创建\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-64249bae", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64249bae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview-loader?{"prefix":false}!./src/components/new-register/create-company.vue
// module id = 1313
// module chunks = 61